// extracted by mini-css-extract-plugin
export var disclaimer_container = "footer-module--disclaimer_container--pvAIX";
export var links_container = "footer-module--links_container--z2+8B";
export var social_icons_container = "footer-module--social_icons_container--gSHyw";
export var social_links_container = "footer-module--social_links_container--eOc-+";